<template>

    <app-layout title="Dashboard">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Tenants
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-2 py-2">
                    <DxTabPanel v-model:selected-index="selectedIndex">


                        <DxItem icon="fields" title="Field List">

                            <template #default>
                                <FieldList @send="recieve" :modulekey="modulekey" :studio="studio" :slug="slug"
                                    ref="fields_builder_list" @callAddTab="addTab(target)" />
                            </template>
                        </DxItem>

                        <DxItem :title="FieldTitle" :slug="slug" icon="checklist">
                            <template #default>
                                <AddField @send="recieve" :modulekey="modulekey" :tabData="tabData" :slug="slug"
                                    :edit="editmode" :studio="studio" ref="fields_builder_add_field" />
                            </template>
                        </DxItem>

                        <DxItem :title="ddTitle" icon="floppy" :disabled="false">
                            <template #default>

                                <AddDropdown @send="recieve" :slug="slug" :edit="ddmode" :tabData="ddData"
                                    ref="add_dropdown_temp" />

                            </template>
                        </DxItem>


                    </DxTabPanel>
                </div>
            </div>
        </div>


    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FieldList from '@/components/builder/fields/fields_builder_list.vue';
import AddField from '@/components/builder/fields/fields_builder_add_field.vue';
import AddDropdown from '@/components/builder/fields/fields_builder_add_dropdown.vue';

import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import DxDataGrid from "devextreme-vue/data-grid";



import service from "./data.js";
import "devextreme-vue/text-area";
export default {
    components: {
        DxTabPanel,
        DxItem,
        DxDataGrid,
        FieldList,
        AddField,
        AddDropdown,
        AppLayout,
    },
    props: ['modulekey', 'studio', 'slug'],
    data() {
        return {
            dataSource: service.getCustomers(),
            selectedIndex: 0,
            columns: ["Name", "DisplayName", "Type"],
            tabData: {},
            ddData: {},
            FieldTitle: "Add Field",
            ddTitle: "Add Dropdown",
            editmode: false,
            ddmode: false,
        };
    },
    methods: {
        recieve(data) {
            this.selectedIndex = data.tabindex;

            this.tabData = data.tabData;
            this.editmode = data.editmode;
            this.ddmode = data.ddmode;
            this.ddData = data.ddData;
            this.FieldTitle = (this.editmode) ? "Edit Field" : "Add Field";
            this.ddTitle = (this.ddmode) ? "Edit Dropdown" : "Add Dropdown";

        },
        addTab(target) {

            //  this.$refs.tabs.addTab(target);
        },
    },
    mounted() {

    }




};
</script>
<style>
.dx-multiview-item-container {
    padding: 10px;
}
</style>